export class BaseRequest {
  public idUsuario: number;
  public versionAplicativo: string;
  public uuid: string;
}
